import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Data } from '@angular/router';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: [],
})
export class FaqComponent implements OnInit {
  filtros = [];
  componenteRef = 'faq';
  stringBusca: string;
  perguntas: any;
  paginaAtual: number;
  totalPaginas: number;
  realizouBusca: boolean;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const { totalPaginas, paginaAtual, itens } = data.faq;
      this.totalPaginas = totalPaginas;
      this.paginaAtual = paginaAtual;
      this.perguntas = itens;
    });
  }

  recebeuInput(input: string[]) {
    this.realizouBusca = true;
    this.stringBusca = input[0];
    this.router.navigate(['/faq'], {
      queryParams: { query: this.stringBusca },
    });
  }

  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.router.navigate(['/faq'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: numeroPagina,
      },
    });
  }
}
